// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  logout:"https://login.microsoftonline.com/2c69625c-08ac-47d2-917b-5258f71dfffa/oauth2/v2.0/logout",
  api: {
    url: 'http://localhost:3000/',
    auth: {
      url: 'authUser'
    },
     redirect: {
      url: 'redirect'
    },
    competition: {
      url: 'competition'
    },
    stadiumCamera: {
      url: '../assets/data/stadium-camera.json'
    },
    aws: {
      url: 'aws'
    },
    mail: {
      url: 'mail'
    },
    sharepoint: {
      url: 'sharepoint'
    },
    picturePark: {
      url: 'picturepark'
    },
    content: {
      url: 'content',
      type: {
        repository: 'repository',
        asset: {
          op: 'asset',
        },
        document: {
          op: 'document',
        },
        assets: {
          op: 'assets',
          topic: 'TOPIC',
          file: 'FILE',
          filesContentTypes:'img,video,pdf',
          storyboard: 'STORYBOARD',
          stadium: 'STADIUM',
          usefulLink: 'USEFUL_LINK'
        },
        search: {
          op: 'search',
          type: 'ASSETS',
          doctype: 'DOCUMENTS'
        }
      }
    }
  },
  gtm: {
    id: 'GTM-53XXGKC',
    env: 'integration'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts